import { render, staticRenderFns } from "./recorder.vue?vue&type=template&id=4a597c34&scoped=true&"
import script from "./recorder.vue?vue&type=script&lang=js&"
export * from "./recorder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a597c34",
  null
  
)

export default component.exports